import { useRef, useState } from "react";
import { Modal, Button } from "@etframework/ui.components";
import { useDeleteTaskType } from "../../data/mutations/taskTypeMutations";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
import { useParams, useNavigate } from "react-router-dom";

export const DeleteTaskTypeConfirmationModal = () => {
  const navigate = useNavigate();
  const { boardId, taskTypeId } = useParams();
  const queryClient = useQueryClient();
  const { mutate: deleteTaskType, isPending } = useDeleteTaskType();
  const { t } = useTranslation(["TaskTypes"], {
    useSuspense: false,
  });

  const onDeleteTaskType = () => {
    deleteTaskType(
      { taskTypeId: taskTypeId },
      {
        onSuccess: async () => {
          onModalClose();
          toast.success(t("DeleteTaskTypeModal.DeleteSuccess"), {
            position: "bottom-left",
          });

          const taskTypes = await queryClient.fetchQuery({
            queryKey: ["get-task-types", boardId],
          });
          if (taskTypes && taskTypes.length > 0) {
            navigate(
              `/duedates/settings/boards/${boardId}/tasktypes/${taskTypes[0]?.Id}`
            );
          }
        },
        onError: () => {
          toast.error(t("DeleteTaskTypeModal.ErrorMsg"), {
            position: "bottom-left",
          });
          onModalClose();
        },
      }
    );
  };

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const onModelBeforeClose = () => {};

  const onModalClose = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const toggleModal = () => {
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const ModalContent = () => {
    return (
      <div className="et-delete-task-type-modal">
        <span className="delete-task-type-header d-block">
          {t("DeleteTaskTypeModal.DeleteTaskTypeHeader")}
        </span>

        <div className="mb-3">
          {t("DeleteTaskTypeModal.DeleteTaskTypeMessage1")}
        </div>
        <div className="mb-3">
          {t("DeleteTaskTypeModal.DeleteTaskTypeMessage2")}
        </div>
        <div className="mb-4">
          {t("DeleteTaskTypeModal.DeleteTaskTypeMessage3")}
        </div>

        <div className="d-flex justify-content-end delete-task-type-modal-btns mx-auto gap-3">
          <Button
            text={t("DeleteTaskTypeModal.Cancel")}
            className="btn-tertiary"
            onClick={toggleModal}
          />
          <Button
            id={
              ModalEvents.DeleteTaskTypeConfirmationModal.Id + "_delete-button"
            }
            text={t("DeleteTaskTypeModal.DeleteTaskType")}
            className="btn btn-danger"
            onClick={onDeleteTaskType}
            loading={isPending}
          />
        </div>
      </div>
    );
  };

  useRegisterEvent(ModalEvents.DeleteTaskTypeConfirmationModal, toggleModal);

  return ReactDOM.createPortal(
    <>
      <Modal
        id={ModalEvents.DeleteTaskTypeConfirmationModal.Id}
        ref={modalRef}
        isModal
        showCloseIcon={true}
        visible={showModal}
        content={<ModalContent />}
        close={onModalClose}
        beforeClose={onModelBeforeClose}
        minHeight="20vh"
        width="487px"
      ></Modal>
    </>,
    document.body
  );
};
